import React from "react";
import Logo from "../../Assets/logo.png";
import { Link } from "react-router-dom";

import "./header.css";
const Header = () => {
  return (
    <div className="header-container">
      <div>
        <img src={Logo} alt="CTET Mastermind" className="logo" />
      </div>
      <div className="menu-container">
        <div>
          <Link to="/" className="menu">
            Home
          </Link>
        </div>
        <div>
          <Link to="/aboutus" className="menu">
            About
          </Link>
        </div>
        <div>
          <Link to="/courses" className="menu">
            Courses
          </Link>
        </div>
        <div>
          <Link to="/gallery" className="menu">
            Gallery
          </Link>
        </div>
        <div>
          <Link to="/contactus" className="menu">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
